// extracted by mini-css-extract-plugin
module.exports = {"settings":"ClassSettings_settings__PZNQE","settings__item":"ClassSettings_settings__item__1lEwg"};